export const selectUsersTaxableLicensePeriods = (state) =>
  state.dashboard.usersTaxableLicenses;
export const selectUsersTaxableLicensePeriodsInProgress = (state) =>
  state.dashboard.isGetUsersTaxableLicensesInProgress;
export const selectUsersTaxableLicensePeriodsSuccess = (state) =>
  state.dashboard.isGetUsersTaxableLicensesSuccess;
export const selectUsersTaxableLicensePeriodsErrorMsg = (state) =>
  state.dashboard.usersTaxableLicensesErrorMsg;
